module.exports = __webpack_public_path__ + "img/rule_3.a84cc4a9.png";